import React, { createContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectProjectBySlug } from "../../selectors/projectSelector";
import RecordingList from "../lists/RecordingList";
import { LoaderWithDelay } from "../helpers";
import { recordingStatuses } from "../../constants";
import { ProjectFilterButtons } from "../buttons";
import { BreadcrumbsWithParams } from "../helpers";

const filtersInitState = {
  user: recordingStatuses.ALL,
  reviewer: recordingStatuses.ALL,
};

export const RecordingsFilterContext = createContext({
  filters: filtersInitState,
  setFilters: () => {},
});

const ProjectPage = () => {
  const { projectSlug } = useParams();
  const [filters, setFilters] = useState(filtersInitState);
  const project = useSelector((state) =>
    selectProjectBySlug(state.projects, projectSlug)
  );
  const projFetchError = useSelector((state) => state.projects.error);
  return (
    <>
      {!project && !projFetchError.message && (
        <LoaderWithDelay size="massive" active />
      )}
      {project && (
        <RecordingsFilterContext.Provider value={{ filters, setFilters }}>
          <BreadcrumbsWithParams />
          <ProjectFilterButtons />
          <RecordingList project={project} />
        </RecordingsFilterContext.Provider>
      )}
    </>
  );
};

export default ProjectPage;
